import React from 'react';
import { FutureRaceDetailLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { NextRaceBreadcrumbs } from './next-race-breadcrumbs';
import { PlatformTypes } from '@om-fe/utils';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { useParams } from 'react-router';

interface FutureRaceListRouteParams {
  readonly sportId: string;
}


type FutureRaceListPageProps = {
  readonly deviceType: PlatformTypes;
  readonly sportId: string;
}

const FutureRaceList = ({
  deviceType,
}: FutureRaceListPageProps) => {
  const { sportId } = useParams<FutureRaceListRouteParams>();

  return (
    <>
      <NextRaceBreadcrumbs isLarge={deviceType === 'desktop' ? true : false} deviceType={deviceType} sportId={sportId} />
      <FutureRaceDetailLoadLazy deviceType={deviceType} />
    </>
  );
}

export const FutureRaceListPage = connect((state: AppState) => {
  return {
    deviceType: state.deviceInfo?.platform.type,
  }
})(FutureRaceList);